import { Link } from "react-router-dom";
import { Heart, Inbox, LogOut, UserRound } from "lucide-react";
import { toast } from "sonner";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { useAuth } from "@/context/AuthContext";

/** "Sign in" for visitors; account menu (saved homes, sign out) for signed-in buyers and the team. */
export const AccountButton = ({ light }) => {
  const { user, saved, requireAccount, logout } = useAuth();
  const tone = light ? "text-white border-white/60 hover:bg-white hover:text-ink" : "text-ink border-neutral-300 hover:border-ink";
  if (!user) {
    return (
      <button onClick={() => requireAccount(null, null, "login")} data-testid="header-signin-button"
        className={`inline-flex h-10 items-center gap-1.5 rounded-full border px-4 text-[14px] transition-colors ${tone}`}>
        <UserRound className="h-4 w-4" /> <span className="hidden sm:inline">Sign in</span>
      </button>
    );
  }
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="header-account-button" className={`inline-flex h-10 items-center gap-2 rounded-full border px-3 text-[14px] transition-colors ${tone}`}>
          <span className="grid h-6 w-6 place-items-center rounded-full bg-brass text-[12px] font-semibold text-ink">{(user.name || user.email)[0].toUpperCase()}</span>
          <span className="hidden max-w-[110px] truncate sm:inline">{user.name?.split(" ")[0] || "Account"}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56" data-testid="account-menu">
        <DropdownMenuLabel className="font-normal"><span className="block text-[14px] text-ink">{user.name}</span><span className="text-[12px] text-neutral-500">{user.email}</span></DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem asChild><Link to="/search?saved=1" data-testid="account-saved-link"><Heart className="mr-2 h-4 w-4" /> Saved homes ({saved.length})</Link></DropdownMenuItem>
        {user.role === "admin" && <DropdownMenuItem asChild><Link to="/admin" data-testid="account-admin-link"><Inbox className="mr-2 h-4 w-4" /> Team inbox</Link></DropdownMenuItem>}
        <DropdownMenuSeparator />
        <DropdownMenuItem onSelect={async () => { await logout(); toast("Signed out"); }} data-testid="logout-button"><LogOut className="mr-2 h-4 w-4" /> Sign out</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
